var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagPuertoRico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C10.7655 0 6.11834 2.51394 3.19934 6.4H28.8007C25.8817 2.51394 21.2345 0 16 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0001C21.2345 32.0001 25.8817 29.4862 28.8007 25.6001H3.19934C6.11834 29.4862 10.7655 32.0001 16 32.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 17.096 0.1105 18.1661 0.320437 19.2H31.6797C31.8896 18.1661 32 17.096 32 16C32 14.9041 31.8895 13.834 31.6796 12.8H0.320437C0.1105 13.834 0 14.9041 0 16H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68622 4.68628C-1.56215 10.9347 -1.56215 21.0653 4.68622 27.3138C7.26828 24.7317 9.75159 22.2484 16 16L4.68622 4.68628Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4756 11.8262L7.51154 15.0147H10.8644L8.15204 16.9854L9.18791 20.174L6.4756 18.2034L3.76316 20.174L4.79929 16.9854L2.08691 15.0147H5.43954L6.4756 11.8262Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPuertoRico);
export default __webpack_public_path__ + "static/media/flag_puerto_rico.525ab6d3d83fe403e3b22686b3c5606c.svg";
export { ForwardRef as ReactComponent };